export default "__VITE_ASSET__CQtw94dV__"